import * as React from 'react';
import { FC, useEffect } from 'react'
import axios from 'axios';
import { Link } from 'react-router-dom';
interface props {
    rtb: {
        CampaignID: number;
        bidID: number;
        bid_price: number;
        imageurl: string;
        urlredirect: string;
    },
    ap: any;
    passPortal: any;
    DeviceID: string;
}

export const RTBBanner: FC<props> = ({rtb, ap, passPortal, DeviceID}) => {

    useEffect(() => {
        _postImpressionRTBanner( `rtb-${rtb.bidID}`);
    }, []);
    
    const _postImpressionRTBanner = async(mediaType: string, portal?: boolean) => {
        try {
          const fields = {
            AccessPointID: ap.ap_mac,
            LocationID: Number(ap.ap_locationid),
            DeviceID,
            CampaignID: rtb.CampaignID,
            MediaType: mediaType
          };
          await axios.post("/impressions", { fields });
          if(portal) {
            passPortal(ap, {CampaignID: rtb.CampaignID}, DeviceID, rtb)
          }
        } catch (err) {
          console.log(err);
        }
      }
   
    return (

      <div className="row w-100 m-0">
    
      <Link
        className="col-11 card m-0  flex-row  align-items-center"
        style={{
          boxShadow: "0px 6px 26px 1px rgba(0,0,0,0.13)",
          color: "black",
          height: "6.8em",
          backgroundImage: `url(${rtb.imageurl.includes("storage.googleapis") ? `/google-storage/${encodeURIComponent(rtb.imageurl)}` : rtb.imageurl})`,
          backgroundPosition: "center",
          backgroundSize: "cover"
        }}
        onClick={() => _postImpressionRTBanner(`bannerClick-${rtb.bidID}`, true)}
        to={{
        
        }}
      >     
       
      </Link>
      <div className="col-1 m-0 p-0">
        <button className="btn btn-lg btn-danger w-100" 
            style={{
              height: "100%",
              textAlign: "center",
              padding: 0,
              borderRadius: "0px 20px 20px 0px"
            }}>&raquo;</button>
        </div>
      </div>
        
 
    )
}
